import React, { useState, useRef, useEffect, useMemo } from "react";
import "./scss/multi-search-select.scss";

export default function SingleSearchSelect({
  label,
  value = null,
  onChange,
  options = [],
  className = ""
}) {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  const isActive = open || !!value;

  const selectedLabel = useMemo(() => {
    const found = options.find(o => o.value === value);
    return found ? found.label : "";
  }, [value, options]);

  useEffect(() => {
    function handleClickOutside(e) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  function handleSelect(val) {
    onChange?.(val);
    setOpen(false);
  }

  function clear(e) {
    e.stopPropagation();
    onChange?.(null);
  }

  return (
    <div
      className={`multi-search-select ${className} ${
        isActive ? "active" : ""
      }`}
      ref={wrapperRef}
    >
      <div
        className="multi-search-select__input-wrapper"
        onClick={() => setOpen(!open)}
      >
        <input
          value={selectedLabel}
          readOnly
        />

        <label>{label}</label>

        {value && (
          <button
            type="button"
            className="multi-search-select__clear"
            onClick={clear}
          >
            ×
          </button>
        )}

        <button
          type="button"
          className={`multi-search-select__arrow ${
            open ? "open" : ""
          }`}
        >
          ⌃
        </button>
      </div>

      {open && (
        <div className="multi-search-select__dropdown">
          {options.map(option => (
            <div
              key={option.value}
              className={`multi-search-select__option ${
                value === option.value ? "selected" : ""
              }`}
              onClick={() => handleSelect(option.value)}
            >
              <span>{option.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
